$illJq(function(){
	
	/****************************************************************************
	* PeakPerformance直営店一覧　「詳細を見る」ボタンクリックで開く
	*****************************************************************************/
	$illJq(".js_detail_area,.js_close_detail").hide();

	$illJq(".js_show_detail").on("click",function(){
		$illJq(this).parents(".button_wrap").siblings(".js_detail_area").slideToggle();
		$illJq(this).hide();
		$illJq(this).siblings(".js_close_detail").show();
	});
	$illJq(".js_close_detail").on("click",function(){
		$illJq(this).parents(".button_wrap").siblings(".js_detail_area").slideToggle();
		$illJq(this).hide();
		$illJq(this).siblings(".js_show_detail").show();
	});


	/****************************************************************************
	* PeakPerformance直営店一覧　追加画像スライダー
	****************************************************************************/
	var shoplistSliderBox = '.js_shoplist_slider';

	// 「詳細を見る」をクリックしたら最初だけイベント登録
	$illJq(".js_show_detail").one("click",function(){
		$illJq(this).parent(".button_wrap").siblings(".js_detail_area").find(shoplistSliderBox).slick({
			  infinite: true,
			  arrows:true,
			  autoplay:false,
			  dots:true,
			  centerMode:true,
			  centerPadding:"0px"
		});
	});
	
	
	/****************************************************************************
	* tab切り替え
	****************************************************************************/

  var tabBtn = ".js-tab-btn-wrap";// タブ切り替えボタンのclass
  var tabCon = ".js-tab-contents";// タブコンテンツのclass
  var activeClass= "active";//表示フラグのclass
  var fadeSpd = 0;// フェードの速度

  // 表示フラグのclassがない場合
  if( $illJq( tabBtn+' .'+activeClass ).length == 0 ){
    // 一番最初のタブを表示
    $illJq( tabBtn + ' > li:first-child' ).addClass( activeClass );
  }

  // タブの数だけ処理
  $illJq( "ul" + tabBtn ).each( function(){

    // クリックされたタブのインデックスを取得
    var firstIndex = $illJq( this ).children( "."+activeClass ).index();

    // コンテンツを表示
    $illJq( this ).siblings( tabCon ).css( "position", "relative" );
    $illJq( tabCon ).children( "li" ).css({
      "display":"none",
       "position":"absolute",
       "top":0,
       "left":0
    });

    // 最初のliだけ↑で付加したcssを取る。
    $illJq( tabCon + " > li:first-child" ).css({
      "display":"",
      "position":""
    });

    // activeがついているボタンに対応するtabCon liのdisplay、positionのクラスを取る。
    $illJq( this ).siblings( tabCon ).children( "li" ).eq( firstIndex ).css({
      "display":"",
      "position":""
    });
   
  });
  
  

  // ボタンをクリックしたときの処理
  $illJq( "ul"+tabBtn+" li" ).click( function(){

    // クリックしたボタンが何番目か。
    var index = $illJq( this ).parent( "ul" ).children( "li" ).index( this );

    // 他のliについているactiveクラスを取る。

    $illJq( this ).siblings( "li" ).removeClass( activeClass );

    // activeを付ける。
    $illJq( this ).addClass( activeClass );

    // tabConのliにabsoluteを付加し、フェードアウトする。
    $illJq( this ).parent( "ul" ).siblings( tabCon ).children( "li" ).css( "position","absolute" ).fadeOut( fadeSpd );

    // tabConのliにクリックしたボタンのコンテンツのpositionを取ってフェードインする。
    $illJq( this ).parent( "ul" ).siblings( tabCon ).children( "li" ).eq( index ).css( "position","" ).stop().fadeIn( fadeSpd );
  });


  // guide-first-navi-contents　”会員についてはこちらのアイコン”をクリックしたときの処理
  $illJq( ".link-member" ).click( function(){

    // tabConのliにabsoluteを付加し、フェードアウトする。
    $illJq( tabCon ).children( "li" ).css( "position","absolute" ).fadeOut( fadeSpd );

    // 該当するボタンのコンテンツのpositionを取ってフェードインする。
    $illJq( ".member-content"  ).css( "position","" ).stop().fadeIn( fadeSpd );
  });

    // guide-first-navi-contents　”修理についてこちら”をクリックしたときの処理
  $illJq( ".link-repair" ).click( function(){

    // tabConのliにabsoluteを付加し、フェードアウトする。
    $illJq( tabCon ).children( "li" ).css( "position","absolute" ).fadeOut( fadeSpd );

    // 該当するボタンのコンテンツのpositionを取ってフェードインする。
    $illJq( ".repair-content"  ).css( "position","" ).stop().fadeIn( fadeSpd );
  });

  // guide-first-navi-contents　”返品交換についてこちら”をクリックしたときの処理
  $illJq( ".link-change" ).click( function(){

    // tabConのliにabsoluteを付加し、フェードアウトする。
    $illJq( tabCon ).children( "li" ).css( "position","absolute" ).fadeOut( fadeSpd );

    // 該当するボタンのコンテンツのpositionを取ってフェードインする。
    $illJq( ".change-content"  ).css( "position","" ).stop().fadeIn( fadeSpd );
  });
	
});